import { baseClient } from './baseRequest';

export enum PayoutStatus {
  Pending = 'pending',
  Completed = 'completed',
}

export type PaymentStatus = {
  isSetupComplete: boolean;
  lastPaymentStatus: PayoutStatus | null;
};

export type PaymentApiClient = {
  getPaymentStatus: () => Promise<PaymentStatus | null>;
};

const paymentApiClient: PaymentApiClient = {
  getPaymentStatus: () =>
    baseClient.get<PaymentStatus>({ url: `/studio/payment/status` }),
};

export default paymentApiClient;
